import { Component } from "react";

/** Replaces a blank white screen with something the user can read, copy and recover from. */
export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Kept in the console so a user can copy the detail into a bug report.
    console.error("Campus Connections crashed:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const msg = this.state.error?.message || String(this.state.error);
    return (
      <div className="min-h-screen flex items-center justify-center p-8 bg-zinc-50" data-testid="app-error-screen">
        <div className="max-w-lg w-full bg-white border rounded-xl p-8 shadow-sm">
          <h1 className="text-xl font-semibold text-zinc-900">Something went wrong on this screen</h1>
          <p className="text-sm text-zinc-600 mt-2">
            Your work was saved up to this point. Reload to carry on — if it keeps happening, send Campus
            Relations the message below.
          </p>
          <pre className="mt-4 text-[11px] bg-zinc-900 text-zinc-100 rounded-md p-3 overflow-x-auto whitespace-pre-wrap"
            data-testid="app-error-message">{msg}</pre>
          <div className="flex gap-2 mt-5">
            <button onClick={() => window.location.reload()} data-testid="app-error-reload"
              className="px-4 py-2 rounded-md bg-cc-blue text-white text-sm font-medium hover:bg-cc-blue-dark">
              Reload this page
            </button>
            <button onClick={() => { window.location.href = "/dashboard"; }} data-testid="app-error-dashboard"
              className="px-4 py-2 rounded-md border text-sm font-medium text-zinc-700 hover:bg-zinc-50">
              Back to my dashboard
            </button>
          </div>
        </div>
      </div>
    );
  }
}
